import type { ReporterRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'reporter'
const reporterRefProvider = getSiteFeatureBoundRefProvider(featureName)

const reporterRefs: ReporterRefs = {
	trackEvent: () => reporterRefProvider(['trackEvent']),
	register: () => reporterRefProvider(['register']),
}
export { reporterRefs }
